export const NAMESPACE = 'ccfEntries';
